import { useNavigate } from 'react-router-dom';

const services = [
  {
    icon: 'ri-smartphone-line',
    title: 'iPhone 維修',
    desc: '螢幕更換、電池更換、鏡頭維修、主板維修等全系列服務',
    items: ['螢幕總成更換', '電池健康恢復', '後鏡頭更換', '主板維修'],
    color: 'bg-blue-50 text-blue-500',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svc1.jpg',
  },
  {
    icon: 'ri-tablet-line',
    title: 'iPad 維修',
    desc: 'iPad Pro/Air/Mini 全系列螢幕、電池、充電口維修',
    items: ['螢幕玻璃更換', '電池更換', '充電口維修', 'Face ID 修復'],
    color: 'bg-purple-50 text-purple-500',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svc2.jpg',
  },
  {
    icon: 'ri-macbook-line',
    title: 'MacBook 維修',
    desc: 'MacBook Air/Pro 螢幕、鍵盤、主板、進水搶救服務',
    items: ['螢幕更換', '鍵盤維修', '主板清洗', '進水搶救'],
    color: 'bg-gray-50 text-gray-600',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svc3.jpg',
  },
  {
    icon: 'ri-android-line',
    title: 'Android 維修',
    desc: 'Samsung、ASUS、Google Pixel 等品牌全系列維修',
    items: ['螢幕更換', '電池更換', '折疊機維修', '後鏡頭維修'],
    color: 'bg-green-50 text-green-500',
    image: 'https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/svc4.jpg',
  },
];

export default function ServicesSection() {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 text-orange-500 text-sm font-medium mb-3">
            <span className="w-8 h-px bg-orange-500" />
            服務項目
            <span className="w-8 h-px bg-orange-500" />
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            全方位裝置維修服務
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto">
            從智慧型手機到筆記型電腦，我們提供全系列品牌維修，專業技師，快速可靠
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {services.map((s) => (
            <div
              key={s.title}
              onClick={() => navigate('/services')}
              className="group bg-white border border-gray-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <div className={`inline-flex items-center justify-center w-10 h-10 rounded-xl ${s.color} mb-3`}>
                  <i className={`${s.icon} text-lg`} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{s.title}</h3>
                <p className="text-gray-500 text-sm mb-4 leading-relaxed">{s.desc}</p>

                <ul className="space-y-1.5 mb-5">
                  {s.items.map((item) => (
                    <li key={item} className="flex items-center gap-2 text-xs text-gray-600">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-orange-500 text-sm" />
                      </div>
                      {item}
                    </li>
                  ))}
                </ul>

                <div className="flex items-center gap-1 text-orange-500 text-sm font-medium group-hover:gap-2 transition-all">
                  查看詳情
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Data Recovery Highlight Card */}
        <div
          onClick={() => navigate('/services/data-recovery')}
          className="mt-8 rounded-2xl cursor-pointer group bg-gray-950 overflow-hidden"
        >
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 px-10 py-10">
            <div className="flex items-center gap-6">
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/20 border border-orange-500/40 rounded-2xl flex-shrink-0">
                <i className="ri-database-2-line text-orange-400 text-3xl" />
              </div>
              <div>
                <div className="inline-flex items-center gap-1.5 bg-orange-500/20 text-orange-400 text-xs font-semibold px-3 py-1 rounded-full mb-2">
                  <i className="ri-star-line text-xs" />
                  特色服務
                </div>
                <h3 className="text-2xl font-bold text-white mb-1">手機資料救援</h3>
                <p className="text-gray-400 text-sm max-w-lg leading-relaxed">
                  進水、摔壞、系統崩潰？<strong className="text-orange-400">救得到才收費</strong>——免費診斷，支援 iPhone、Samsung、ASUS 等全品牌，最快當天完成。
                </p>
              </div>
            </div>

            <div className="flex flex-col items-start md:items-end gap-3 flex-shrink-0">
              <div className="flex flex-wrap gap-2">
                {['免費診斷', '救到才收費', '隱私保密'].map((tag) => (
                  <span key={tag} className="bg-white/10 text-white text-xs px-3 py-1 rounded-full whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
              <div className="flex items-center gap-2 bg-orange-500 group-hover:bg-orange-600 text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-colors whitespace-nowrap">
                了解資料救援服務
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <button
            onClick={() => navigate('/services')}
            className="px-8 py-3 border-2 border-gray-900 hover:bg-gray-900 hover:text-white text-gray-900 font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部服務
          </button>
        </div>
      </div>
    </section>
  );
}
